import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import KonfhubContainer from "../../../revampComponents/Atom/Container";
import AddNEditTask from "./AddNEditTask";
import { cleanPayload, convertToEventTimeZone, convertToUTC, LABELS, validationSchema } from "./TaskManagementConstant";
import { diffAndCommon } from "../../../services/util";
import { createTask, updateTask, getAllTasks } from "../../../revampCRUD/taskManagement.crud";
import customToast from "../../../components/common/basic/Toast";
import { useFormik } from "formik";
import { ErrMessages, CrudMessages } from "../../EventInfo/config/error-constants";
import LoadingSpinner from "../../../revampComponents/Atom/Loading";
const AddNEditInterface = (props) => {
  const { eventId, taskId } = useParams();
  const history = useHistory();
  const location = useLocation();
  const entityCategoryId = location.state?.entityCategoryId;
  const exhibitorId = location.state?.exhibitorId;
  const [isEdit, setIsEdit] = useState(!!taskId);
  const [edit,setEdit]=useState(false)
  const [loading, setLoading] = useState(false);
  const [editCategorIds, setEditCategoryIds] = useState([]);
  const [isExhibitorToggle, setIsExhibitorToggle] = useState(false);
  const [taskDetails, setTaskDetails] = useState({
    task_type: "",
    title: "",
    description: "",
    priority: "",
    due_date: "",
    files: [],
    reminder_date: "",
    category_ids: [],
    exhibitor_ids: [],
  });

  const formik = useFormik({
    initialValues: taskDetails,
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      const updated_details = diffAndCommon("diff", [values, formik.initialValues], []);
      let cleanedDetails = cleanPayload(updated_details);
      delete cleanedDetails.category_ids;
      delete cleanedDetails.exhibitor_ids;

      const payload = {
        ...cleanedDetails,
        task_column_mapping: values.task_column_mapping || "custom_task",
    };
    
    // Only include if value changed in edit mode
    if (isEdit) {
        if (!_.isEqual(values.category_ids, formik.initialValues.category_ids)) {
            payload.category_ids = values.category_ids;
        }
        if (!_.isEqual(values.exhibitor_ids, formik.initialValues.exhibitor_ids)) {
            payload.exhibitor_ids = values.exhibitor_ids;
        }
    } else {
        if (isExhibitorToggle) {
            payload.exhibitor_ids = values.exhibitor_ids;
        } else {
            payload.category_ids = values.category_ids;
        }
    }
    // Convert due_date and reminder_date before sending in create mode
          if (values.due_date && !_.isEqual(values.due_date, formik.initialValues.due_date)) {
            payload.due_date = convertToUTC(values.due_date);
          }
          if (values.reminder_date && !_.isEqual(values.reminder_date, formik.initialValues.reminder_date)) {
            payload.reminder_date = convertToUTC(values.reminder_date);
          }
        try {
        let response;
        if (isEdit) {
          response = await updateTask(taskId, payload);
        } else {
          response = await createTask({...payload,task_column_mapping: values.task_column_mapping || "custom_task" });
        }

        if (response.data) {
          customToast.success(isEdit ? CrudMessages.UPDATE_MESSAGE : CrudMessages.ADDED_MESSAGE);
          formik.resetForm();
          history.push(exhibitorId
            ? `/e/${eventId}/exhibitor-portal/${exhibitorId}/tasks`
            : `/e/${eventId}/exhibitor-portal/task-management`)
        } else {
          customToast.error(ErrMessages.DEFAULT_ERROR_MESSAGE);
        }
      } catch (err) {
        customToast.error(ErrMessages.INTERNAL_SERVER_ERROR);
      } finally {
        setLoading(false);
      }
    },
  });
  const memoizedTaskDetails = useMemo(
    () => JSON.parse(JSON.stringify(taskDetails)),
    [JSON.stringify(taskDetails)]
  );
  const isFirstRender = useRef(true);

useEffect(() => {
  if (isFirstRender.current) {
    isFirstRender.current = false;
    formik.resetForm({ values: memoizedTaskDetails });
  }
}, [memoizedTaskDetails, isEdit]);

  

  useEffect(() => {
    if (taskId) {
      setLoading(true);
      setIsEdit(true);
      setEdit(true)
      const fetchTaskDetails = async () => {
        try {
          const response = await getAllTasks();
          const tasks = response.data.tasks || [];
          const task = tasks.find((t) => t.task_id === taskId);

          if (task) {
            const { exhibitor_ids, exhibitors,due_date, reminder_date, ...taskDetails } = task; 
            const exhId = exhibitors?.map((exh) => exh.id.toString()) || [];
            const convertedDueDate = convertToEventTimeZone(due_date, props?.eventInfo);
            const convertedReminderDate = convertToEventTimeZone(reminder_date, props?.eventInfo)
            
            setTaskDetails({ exhibitor_ids: task.category_ids.length> 0 ? [] : exhId,exhibitors:task.exhibitors, category_ids: task.category_ids || [],due_date: convertedDueDate,
            reminder_date: convertedReminderDate, ...taskDetails }); 
            formik.setFieldValue("exhibitors", task.category_ids.length> 0 ? []: task.exhibitors);
            formik.setFieldValue("category_ids", task.category_ids || []);
            setEditCategoryIds(formik.values.category_ids || []);
            setLoading(false);
        }
        
        } catch (error) {
          customToast.error("Error fetching task details");
        }
      };
      fetchTaskDetails();
    }
  }, [taskId,isEdit,edit]);

  useEffect(() => {
    if (exhibitorId && !isEdit) {
      const updatedTaskDetails = {
        ...taskDetails,
        exhibitor_ids: [exhibitorId], 
        category_ids:  [],
      };
  
      setTaskDetails(updatedTaskDetails);
            if (!formik.values.exhibitor_ids.length) {
        formik.setValues(updatedTaskDetails);
      }
    }
  }, [exhibitorId,isEdit]);


  useEffect(() => {
    if (location.state?.isPredefinedTask && location.state?.predefinedTaskDetails) {
      const { module_name, task_type,task_column_mapping } = location.state.predefinedTaskDetails;

      if (formik.values.title !== module_name) {
        formik.setFieldValue("title", module_name);
      }
      if (formik.values.task_type !== task_type) {
        formik.setFieldValue("task_type", task_type);
      }
      if (formik.values.task_column_mapping !== task_column_mapping) {
        formik.setFieldValue("task_column_mapping", task_column_mapping);
      }
    }
  }, [location.state?.isPredefinedTask, location.state?.predefinedTaskDetails , formik.values]);

  return (
    <>
    {loading ? <LoadingSpinner /> :   <KonfhubContainer>
        <h4 className="px-4 pt-2 task-edit-add-title">
          {isEdit ? LABELS.EDIT_TASK : LABELS.CREATE_TASK}
        </h4>
        <AddNEditTask
          formik={formik}
          setTaskDetails={setTaskDetails}
          predefinedTaskDetails={location.state?.predefinedTaskDetails || {}}
          isPredefinedTask={location.state?.isPredefinedTask || false}
          editCategorIds={editCategorIds}
          setEditCategoryIds={setEditCategoryIds}
          isEdit={isEdit}
          entityCategoryId={entityCategoryId}
          exhibitorId={exhibitorId}
          taskDetails={taskDetails}
          edit={edit}
          setEdit={setEdit}
          eventDetails={props.eventInfo}
          setIsExhibitorToggle={setIsExhibitorToggle}
        />
      </KonfhubContainer> }
      <style>
        {`
          .task-edit-add-title {
            color: var(--primaryColor) !important;
            font-weight: 600;
            font-size: 18px;
          }
        `}
      </style>
    </>
  );
};

export default AddNEditInterface;
